import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Skeleton } from "@mantine/core";
import FormattedNumber from "../../utils/fixPrice";
import calculatePercentageChange from "../../utils/percentageMove";
import { FaCaretUp, FaCaretDown } from "react-icons/fa6";
import { Link } from "react-router-dom";
import formatUrl from "../../utils/formatedUrls";

const CarouselCard = ({ p, isLarge }) => {
  const { projects: newProjects, isLoading } = useSelector(
    (state) => state.projects
  );
  return (
    <div
      id={p.id}
      style={{ paddingLeft: "16px", width: "300px" }}
      className={`shrink-0 grow-0 always-snap snap-start basis-[45%]  xs:basis-1/2 sm:basis-1/2 md:basis-1/2 lg:basis-1/2 xl:basis-1/3 max-w-[45%] xs:max-w-1/2 sm:max-w-1/2 md:max-w-1/2 lg:max-w-1/2 ${
        isLarge ? "xl:max-w-1/4" : "xl:max-w-1/3"
      }`}
    >
      <Skeleton visible={isLoading}>
        <Link to={`/projects/${formatUrl(p.network, p.name)}`}>
          <div className="relative card-width overflow-hidden rounded-xl border border-neutral-20 bg-neutral-0 dark:border-neutral-95 dark:bg-neutral-95 shadow-black-5 transition-all duration-200 dark:shadow-black-40 h-full w-full px-3 py-3 sm:px-4 sm:py-4 cursor-pointer hover:border-neutral-40 hover:shadow dark:hover:border-transparent dark:hover:brightness-[120%] text-neutral-100 dark:text-neutral-0">
            <div className="absolute inset-0 flex flex-col justify-end opacity-50"></div>
            <div className="relative flex h-full min-h-[80px] flex-col justify-between">
              <div className="flex w-full items-center justify-between">
                <div className="flex w-full items-center">
                  <div className="relative h-9 w-9 lg:h-10 lg:w-10">
                    <img src={p.logo} className="rounded-full object-cover" />
                  </div>
                  <div className="ml-2 flex min-w-0 max-w-full flex-1 flex-col gap-1">
                    <h2 className="max-w-full truncate text-sm font-medium">
                      {p.name}
                    </h2>
                    {/* <div className="flex flex-nowrap items-center gap-2 whitespace-nowrap font-medium text-xs">
                    {p.presale ? (
                      <div className="text-success-main flex gap-1 items-center">
                        <span className="text-xs">PRESALE</span>
                      </div>
                    ) : null}
                    {p.fairlaunch ? (
                      <div className="text-warning-main flex gap-1 items-center">
                        <span className="text-xs">FAIR LAUNCH</span>
                      </div>
                    ) : null}
                  </div> */}

                    <div className="flex items-center">
                      <div className="flex flex-nowrap items-center gap-1 whitespace-nowrap font-medium text-xs">
                        <FormattedNumber number={p?.priceUsd?.toFixed(24)} />
                        {p?.priceUsd24hAgo?.toFixed(24) === undefined ? (
                          <span></span>
                        ) : (
                          <div
                            style={{ fontSize: 12 }}
                            className={`flex w-fit items-center font-semibold text-2xs  ${
                              p?.priceUsd?.toFixed(24) >
                              p?.priceUsd24hAgo?.toFixed(24)
                                ? "text-success-main"
                                : "text-primary-main"
                            } bg-transparent`}
                          >
                            {p?.priceUsd?.toFixed(24) >
                            p?.priceUsd24hAgo?.toFixed(24) ? (
                              <FaCaretUp />
                            ) : (
                              <FaCaretDown />
                            )}
                            {calculatePercentageChange(
                              p?.priceUsd?.toFixed(24),
                              p?.priceUsd24hAgo?.toFixed(24)
                            )}
                            %
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex w-full items-end justify-between">
                <div
                  className={`-m-1 rounded-lg border-background-light ${
                    p.score < 80 && p.score > 70
                      ? "bg-score-poor-background"
                      : p.score < 70
                      ? "bg-score-alert-background"
                      : "bg-score-good-background"
                  } p-1 dark:border-neutral-80 dark:bg-neutral-100 sm:-m-2 sm:p-2`}
                >
                  <div
                    className={`flex flex-col font-semibold ${
                      p.score < 80 && p.score > 70
                        ? "text-score-poor"
                        : p.score < 70
                        ? "text-score-alert"
                        : "text-score-good"
                    }`}
                  >
                    <div>
                      <span className="text-base leading-4 sm:text-xl sm:leading-6">
                        {p.score}
                      </span>
                      <span className="text-xs leading-4 sm:text-base sm:leading-6 xs:hidden sm:inline md:inline lg:inline xl:inline">
                        .00
                      </span>
                    </div>
                  </div>
                </div>
                <div className="flex items-center gap-1 text-xs font-medium text-neutral-70 dark:text-neutral-30">
                  {p.audit ? (
                    <div className="flex items-center gap-0.5 rounded bg-success-main px-1 py-0.5 text-xs font-semibold text-neutral-0 ">
                      AUDIT
                    </div>
                  ) : null}
                  {p.kyc ? (
                    <div className="flex items-center gap-0.5 rounded bg-warning-main px-1 py-0.5 text-xs font-semibold text-neutral-0 ">
                      KYC
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </Link>
      </Skeleton>
    </div>
  );
};

export default CarouselCard;
